import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// #root may carry a server-rendered snapshot (edge homepage SSR / journal
// prerender) for crawlers & no-JS. Drop it before mounting: React then owns an
// empty container, so the snapshot is never duplicated or reconciled against.
const container = document.getElementById("root");
container.replaceChildren();
const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
